export default function LimitedAvailability() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <div className="bg-gradient-to-br from-yellow-400 to-yellow-500 rounded-3xl p-12 md:p-16 text-center shadow-2xl">
          <div className="w-24 h-24 flex items-center justify-center mx-auto mb-8 bg-purple-900 rounded-full">
            <i className="ri-alarm-warning-line text-5xl text-yellow-400"></i>
          </div>
          
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-black text-purple-900 mb-8 leading-tight px-2">
            Sponsorship Opportunities<br />Are Limited
          </h2>
          
          <div className="space-y-6 text-lg md:text-xl text-purple-900 font-medium max-w-3xl mx-auto">
            <p className="leading-relaxed">
              Each season, we have a <strong>limited number of sponsorship opportunities</strong> available to ensure maximum visibility and value for our partners.
            </p>
            
            <p className="leading-relaxed">
              <strong>Helmet sponsorships are especially limited</strong>—only one sponsor per team. Once they're claimed, they're gone for the season.
            </p>
            
            <p className="leading-relaxed">
              Don't miss your chance to connect with hundreds of local families and show your community support.
            </p>
          </div>
          
          <div className="mt-12 inline-block px-8 py-4 bg-purple-900 text-yellow-400 text-xl font-black rounded-xl">
            Secure Your Spot Today
          </div>
        </div>
      </div>
    </section>
  );
}